// FxRate API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type FxRateRequests = {
    create: RequestConfigFunction<undefined>,
    update: RequestConfigFunction<undefined>,
    get: RequestConfigFunction<{id: number}>,
    selector: RequestConfigFunction<Record<string, any>>
}

const fxRateRequests: FxRateRequests = {
    create: () => {
        return {
            url: 'fxrate',
            method: 'POST',
        }
    },
    update: () => {
        return {
            url: 'fxrate',
            method: 'PUT',
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `fxrate/${id}`,
            method: 'GET',
        }
    },
    selector: (params) => {
        return {
            url: 'fxrate/filter-request/selector',
            method: 'POST',
            data: {
                includeFilters: {
                    ...params,
                },
                rows: 50,
                start: 0,
            },
        }
    },
}

export default fxRateRequests
